
























import { Component, Vue } from 'vue-property-decorator';
import Firebase from '@/class/firebase';

  @Component
export default class Auth extends Vue {
    user: any = {};

    userStatus = false;

    async doLogin(): Promise<void> {
      await Firebase.login();
      this.user = Firebase.findLoginUser();
      this.userStatus = Firebase.loginStatus();
    }

    async doLogout(): Promise<void> {
      await Firebase.logout();
      this.user = Firebase.findLoginUser();
      this.userStatus = Firebase.loginStatus();
    }

    async mounted(): Promise<void> {
      Firebase.init();

      await Firebase.currentUser();
      this.user = Firebase.findLoginUser();
      this.userStatus = Firebase.loginStatus();
    }
}
